import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import NoticesModuleTypes from '@/store/modules/middleGround/my/notices/interface';

const noticesModule: Module<NoticesModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        pageNoticeList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/notice/pageNoticeList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        countNoticeNotRead(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/notice/countNotRead", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        readNotice(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/notice/readNotice", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        addNotice(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/notice/addNotice", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
    },
};

export default noticesModule;